
const purchaseStatusEnum = Object.freeze({
    PENDING : 5,
    ORDERED : 10,
    RECEIVED: 15,
})

export default purchaseStatusEnum;
